/**
 * Get display name for HOCs
 * Used for cleaner names in react dev tools
 */
export default (WrappedComponent: React.ComponentType<any>) =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component'
